import React from 'react';
import {
  LastModifiedCell,
  LastModifiedCellProps,
} from 'ui/indexPages/tables/cells/LastModifiedCell';
import { BaseCellWrapper } from './BaseCell';

export const LastModified: React.FC<LastModifiedCellProps> = React.memo(
  ({ createdAt, createdBy, modifiedAt, modifiedBy }) => {
    return (
      <BaseCellWrapper dataTestId="last-modified-cell">
        <LastModifiedCell
          createdAt={createdAt}
          createdBy={createdBy}
          modifiedAt={modifiedAt}
          modifiedBy={modifiedBy}
        />
      </BaseCellWrapper>
    );
  },
);
